import { render, staticRenderFns } from "./plugin-update-logs.vue?vue&type=template&id=3fe8499b&scoped=true&"
import script from "./plugin-update-logs.vue?vue&type=script&lang=js&"
export * from "./plugin-update-logs.vue?vue&type=script&lang=js&"
import style0 from "./plugin-update-logs.vue?vue&type=style&index=0&id=3fe8499b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe8499b",
  null
  
)

export default component.exports